import './IconDelete.css';
import React from 'react';
import { styled } from 'linaria/lib/react';
var IconDelete = function IconDelete(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 19.278 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 19.5 : _ref$height,
    className = _ref.className,
    _ref$fill = _ref.fill,
    fill = _ref$fill === void 0 ? '#000' : _ref$fill;
  return /*#__PURE__*/React.createElement(StyledSVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 20 20",
    className: className
  }, /*#__PURE__*/React.createElement("path", {
    id: "trash-xmark-svgrepo-com",
    d: "M10.667,11l4.444,4.444m0-4.444-4.444,4.444M4,6.333H21.778m-4.444,0-.3-.9A5.1,5.1,0,0,0,16.325,3.8a2.222,2.222,0,0,0-.891-.642A5.094,5.094,0,0,0,13.66,3H12.118a5.094,5.094,0,0,0-1.774.154,2.222,2.222,0,0,0-.891.642,5.094,5.094,0,0,0-.707,1.635l-.3.9m11.111,0v9.333c0,1.867,0,2.8-.363,3.513a3.333,3.333,0,0,1-1.457,1.457C17.022,21,16.089,21,14.222,21H11.556c-1.867,0-2.8,0-3.513-.363A3.333,3.333,0,0,1,6.586,19.18c-.363-.713-.363-1.646-.363-3.513V6.333",
    transform: "translate(-3.25 -2.25)",
    fill: "none",
    stroke: "#035e88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5"
  }));
};
var StyledSVG = /*#__PURE__*/styled("svg")({
  name: "StyledSVG",
  class: "s189lslb"
});
export default IconDelete;